import { CheckCheck, Contact } from "lucide-react";
import React from "react";
import { exchangeDate } from "../../helpers";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

export default function ReferralPatientDataTable(props) {
  const {
    tableData = [],
    dataLoading,
    setCheckPatientData = () => {},
    toggleAccordion = () => {},
    referPatientData = {},
    setReferPatientData = () => {}
  } = props;

  const selectPatient = (item) => {
    setCheckPatientData(item);
    toggleAccordion(1);
    setReferPatientData({
      ...referPatientData,
      patient_id: item.id,
    });
  }

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th> Patient Information </th>
              <th> Insurance Information </th>
              <th className="docpro_text_center"> Action </th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>

                    <td>
                      <div>
                        <p className="docpro_mb_0">
                          <b>Name: </b> {item?.lastName}{' '}{item?.firstName}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Phone: </b> {item?.mobilePhone}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Birth: </b> {exchangeDate(item?.dob)}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className="docpro_mb_0">
                          <b>Name: </b> {item?.insuranceName}
                        </p>
                        <p className="docpro_mb_0">
                          <b>ID: </b> {item?.insuranceID}
                        </p>
                      </div>
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns" phone={item.mobilePhone}>
                        
                        <button
                          type="button"
                          className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn"
                          onClick={() => selectPatient(item)}
                        >
                          <CheckCheck width={20} height={20} />
                          <span>Select</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="3">
                    <div>
                      No data available. Add patients first to enable referrals <br /><br />
                      <Link to="/patient-database?type=add">
                        <button
                          className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn size_lg"
                        >
                          <Contact width={15} height={15} />
                          <span>Add Patients</span>
                        </button>
                      </Link>
                    </div>
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td>
                    <Skeleton width={`${6 + (index % 2)}rem`} borderRadius="8px"></Skeleton>
                    <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton>
                    <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton>
                  </td>
                  <td>
                    <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton>
                    <Skeleton width={`${4 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton>
                  </td>
                  <td className="text-center"> <Skeleton width="4rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
